<script>
    import smokeMeta from '../data/smoke/smoke.json';

    let {
        title = 'Vertically integrated smoke, mg/m²',
        // Qualitative mode: replace numeric ticks with "Less"/"More" ends.
        qualitative = false,
    } = $props();

    // Convert the color scale (kg/m^2) to mg/m^2 and place value ticks at
    // gamma-correct positions so they align with the map's transfer function.
    const scale = smokeMeta.scale;
    const KG_TO_MG = 1e6;
    const vmaxMg = scale.vmax * KG_TO_MG;
    const tickPos = (mg) => {
        const v = mg / KG_TO_MG;
        const t = Math.min(Math.max((v - scale.vmin) / (scale.vmax - scale.vmin), 0), 1);
        return Math.pow(t, scale.gamma);
    };
    const legendTicks = [
        ...[0, 100, 200].filter((v) => v < vmaxMg).map((v) => ({ label: `${v}`, p: tickPos(v) })),
        { label: `${Math.round(vmaxMg)}+`, p: 1 },
    ];
</script>

<div class="legend">
    <p class="legend-title">{title}</p>
    <div class="legend-scale">
        <!-- ramp mirrors the map: RGB fixed at near_black (#0c0c0c), alpha 0 -> 1 -->
        <div class="legend-bar"></div>
        {#if qualitative}
            <div class="legend-ends">
                <span>Less</span>
                <span>More</span>
            </div>
        {:else}
            <div class="legend-ticks">
                {#each legendTicks as t}
                    <span class="legend-tick" style="left: {t.p * 100}%">
                        <span class="legend-tick-label">{t.label}</span>
                    </span>
                {/each}
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .legend {
        color: #595959;
    }

    .legend-title {
        margin: 0 0 0.35rem;
        font-weight: 600;
        color: #404040;
    }

    .legend-scale {
        width: 240px;
        max-width: 100%;
    }

    .legend-bar {
        height: 10px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        background: linear-gradient(to right, rgba(12, 12, 12, 0), rgba(12, 12, 12, 1));
    }

    .legend-ends {
        display: flex;
        justify-content: space-between;
        margin-top: 3px;
        font-variant-numeric: tabular-nums;
    }

    .legend-ticks {
        position: relative;
        height: 1.4em;
        margin-top: 2px;
    }

    .legend-tick {
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        transform: translateX(-50%);
    }

    /* Keep the first/last labels from spilling past the bar edges. */
    .legend-tick:first-child {
        align-items: flex-start;
        transform: none;
    }

    .legend-tick:last-child {
        align-items: flex-end;
        transform: translateX(-100%);
    }

    .legend-tick-label {
        margin-top: 1px;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }
</style>
